import { render, staticRenderFns } from "./poster.vue?vue&type=template&id=30a2edea&scoped=true"
import script from "./poster.vue?vue&type=script&lang=js"
export * from "./poster.vue?vue&type=script&lang=js"
import style0 from "./poster.vue?vue&type=style&index=0&id=30a2edea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a2edea",
  null
  
)

export default component.exports